<template>
  <div class="one">
    <dl v-for="(item, index) in list" :key="index" @click="goUrl(item.url)">
      <dt>
        <img :src="item.ImageUrl" alt />
      </dt>
      <dd>
        <h3>{{ item.Linkage }}</h3>
        <a href="javascript:;" class="sapn">{{item.title}}</a>
      </dd>
    </dl>
    <dl @click="goWL()">
      <dt>
        <img src="../../../images/66.jpg" alt />
      </dt>
      <dd>
        <h3>物流查询</h3>
        <a href="javascript:;" class="sapn">已购订单物流查询</a>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        // {
        //   ImageUrl: require("../../../images/11.jpg"),
        //   Linkage: "促销活动",
        //   title:'发现惊喜好价和福利',
        //   url:''
        // },
        {
          ImageUrl: require("../../../images/22.jpg"),
          Linkage: "技术支持",
          title:'专业团队高效协助',
          url:'/technicalSupports/learningCenter'
        },
        {
          ImageUrl: require("../../../images/33.jpg"),
          Linkage: "科研服务",
          title:'一站式服务平台',
          url:'/technicalService'
        },
        {
          ImageUrl: require("../../../images/44.jpg"),
          Linkage: "订购指南",
          title:'下单操作小帮手',
          url:'/productCenter'
        },
        {
          ImageUrl: require("../../../images/55.jpg"),
          Linkage: "批量下单",
          title:'大宗购买轻松下单',
          url:'/productCenter'
        }
      ],
    };
  },
  methods: {
    goUrl(url){
      this.$router.push(url)
    },
    goWL(){
      window.open("https://www.kuaidi100.com/", '_blank')
    }
  },
};
</script>

<style lang="less" scoped>
.one {
  display: flex;
  justify-content: space-between;
  flex:1;
  margin: 0px 311px;
  dl {
    display: flex;
    margin-right: 50px;
    cursor: pointer;
    dd {
      width: 87px;
      height:65px;
      h3 {
        font-size: 18px;
        font-weight: 700;
        color: #003871;
        line-height: 21px;
        margin-bottom: 10px;
      }
      .sapn {
        width: 87px;
        height:65px;
        font-size: 15px;
        color: #666666;
        line-height: 16px;
      }
    } 
    dt {
      width: 65px;
      height: 65px;
      margin-right: 20px;
      img {
        width: 65px;
        height: 65px;
      }
    }
  }
}
</style>